
import { getCssValFloat } from '../utils/dp-utils';

export default class DPBoundingBox {

	static actualizeBottomAndRight(element) {
		element.bottom = element.top + element.height - 1;
		element.right = element.left + element.width - 1;
		return element;
	}

	static actualizeHeightAndWidth(element) {
		element.height = element.bottom - element.top + 1;
		element.width = element.right - element.left + 1;
		return element;
	}

	static empty = () => {
		return {
			top: 0,
			width: 0,
			height: 0,
			left: 0
		};
	}

	static area = (bb) => {
		return bb && bb.width > 0 && bb.height > 0 ? bb.width * bb.height : 0;
	}

	static extendBB = (originalBB, extendTopBottomPx, extendLeftRightPx) => {
		if (originalBB && !isNaN(extendTopBottomPx) && !isNaN(extendLeftRightPx)) {
			const resBB = { ...originalBB };
			resBB.top -= extendTopBottomPx;
			resBB.left -= extendLeftRightPx;
			resBB.bottom += extendTopBottomPx;
			resBB.right += extendLeftRightPx;
			return DPBoundingBox.actualizeHeightAndWidth(resBB);
		}
		return null;
	}
	static extendBB = (originalBB, extendSizePx) => {
		if (originalBB && !isNaN(extendSizePx)) {
			const resBB = { ...originalBB };
			resBB.top -= extendSizePx;
			resBB.left -= extendSizePx;
			resBB.bottom += extendSizePx;
			resBB.right += extendSizePx;
			return DPBoundingBox.actualizeHeightAndWidth(resBB);
		}
		return null;
	}
	/**
	 * Get an element position on the page
	 * @api private
	 * @method _getOffset
	 * @param {Object} element
	 * @returns Element's position info
	 */
	static getElBoundingBox = (element, includeMargin = false, relativeToCurrentScrollTop = false, defVal = null, scrollTop = null, scrollLeft = null) => {
		if (element) {
			const jElement = $(element);
			const offset = jElement.offset();
			if (!includeMargin) {

				return DPBoundingBox.boundingBox2RelativeScrollPos(DPBoundingBox.actualizeBottomAndRight({
					top: offset.top,
					left: offset.left,
					width: jElement.outerWidth(false),
					height: jElement.outerHeight(false)
				}), relativeToCurrentScrollTop, scrollTop, scrollLeft);
			}
			else {
				return DPBoundingBox.boundingBox2RelativeScrollPos(DPBoundingBox.actualizeBottomAndRight({
					top: offset.top - getCssValFloat(jElement, 'marginTop', 0),
					left: offset.left - getCssValFloat(jElement, 'marginLeft', 0),
					width: jElement.outerWidth(true),
					height: jElement.outerHeight(true)
				}), relativeToCurrentScrollTop, scrollTop, scrollLeft);
			}
		}
		return defVal;
	}

	static boundingBox2RelativeScrollPos(boundingBox, enabled = true, scrollTop = null, scrollLeft = null) {
		const st = scrollTop === null ? $(window).scrollTop() : scrollTop;
		const sl = scrollLeft === null ? $(window).scrollLeft() : scrollLeft;
		const boundingBoxNew = { ...boundingBox };
		boundingBoxNew.top -= enabled ? st : 0;
		boundingBoxNew.left -= enabled ? sl : 0;
		boundingBoxNew.bottom -= enabled ? st : 0;
		boundingBoxNew.right -= enabled ? sl : 0;
		return boundingBoxNew;
	}

	static mergeBoundingBoxes(...boundingBoxes) {
		if (boundingBoxes.length) {
			const notNulBBs = boundingBoxes.filter(bb => bb);
			const tops = notNulBBs.map(bb => bb.top);
			const lefts = notNulBBs.map(bb => bb.left);
			const bottoms = notNulBBs.map(bb => bb.bottom);
			const rights = notNulBBs.map(bb => bb.right);

			if (tops && tops.length && lefts && lefts.length && bottoms && bottoms.length && rights && rights.length) {
				return DPBoundingBox.actualizeHeightAndWidth({
					top: Math.min(...tops),
					left: Math.min(...lefts),
					right: Math.max(...rights),
					bottom: Math.max(...bottoms)
				});
			}
		}
		return null;
	}

	static intersect(...boundingBoxes) {
		if (boundingBoxes.length) {
			const notNulBBs = boundingBoxes.filter(bb => bb);
			const tops = notNulBBs.map(bb => bb.top);
			const lefts = notNulBBs.map(bb => bb.left);
			const bottoms = notNulBBs.map(bb => bb.bottom);
			const rights = notNulBBs.map(bb => bb.right);

			if (tops && tops.length && lefts && lefts.length && bottoms && bottoms.length && rights && rights.length) {
				const bb = DPBoundingBox.actualizeHeightAndWidth({
					top: Math.max(...tops),
					left: Math.max(...lefts),
					right: Math.min(...rights),
					bottom: Math.min(...bottoms)
				});
				return DPBoundingBox.area(bb) > 0 ? bb : null;
			}
		}
		return null;
	}

	_mergeElementsBoundingBoxes(...elements) {
		return DPBoundingBox.mergeBoundingBoxes(...elements.map(el => DPBoundingBox.getElBoundingBox(el)));
	}



	static diff(bb1, bb2) {
		return {
			top: bb1.top - bb2.top,
			left: bb1.left - bb2.left,
			bottom: bb1.bottom - bb2.bottom,
			right: bb1.right - bb2.right,
			width: bb1.width - bb2.width,
			height: bb1.height - bb2.height,
		};
	}

	static isEqual(bb1, bb2) {
		return bb1.top === bb2.top
			&& bb1.left === bb2.left
			&& bb1.bottom === bb2.bottom
			&& bb1.right === bb2.right;
	}

	static diffAbs(bb1, bb2) {
		const diffBB = DPBoundingBox.diff(bb1, bb2);
		return {
			top: Math.abs(diffBB.top),
			left: Math.abs(diffBB.left),
			bottom: Math.abs(diffBB.bottom),
			right: Math.abs(diffBB.right),
			width: Math.abs(diffBB.width),
			height: Math.abs(diffBB.height)
		};
	}
}